export default import.meta.ROLLUP_FILE_URL_MhWcR$XRgxQ5rgNK1ah66Q